
import { GET_ORDER_ACTIVE_ID } from '../actions/types';
// import isEmpty from '../validation/is-empty';

const initialState = {
  id: []
}

export default function(state = initialState, action ) {
    switch(action.type) {
        case GET_ORDER_ACTIVE_ID:
            // console.log(action.payload);
            return {
                ...state,
                id: action.payload
            }
        default:
            return state;
    }
}
